const ORDER_LOADING = "ORDER_LOADING";
const ORDER_ERROR = "ORDER_ERROR";
const ORDER_SUCCESS = "ORDER_SUCCESS";
export { ORDER_LOADING, ORDER_ERROR, ORDER_SUCCESS };
